import i18n from 'src/i18n.js';

export const initialButtonState = () => [
    {
        btnName: i18n.t('reportUsage.reportUsageFooterbuttons.cancelButton'),
        btnVisibility: true,
        isBtnDisable: false,
        btnType: 'cancel',
    },
    {
        btnName: i18n.t('reportUsage.saveExit'),
        btnVisibility: true,
        isBtnDisable: false,
        btnType: 'secondary',
    },
    {
        btnName: i18n.t('reportUsage.reportUsageFooterbuttons.replenishButton'),
        btnVisibility: true,
        isBtnDisable: true,
        btnType: 'primary',
        screen: 'record',
    },
    {
        btnName: i18n.t('orders.orderListFilters.applyButton'),
        btnVisibility: false,
        isBtnDisable: true,
        btnType: 'primary',
        screen: 'record',
    },
    {
        btnName: i18n.t('reportUsage.progressBar.procedure'),
        btnVisibility: false,
        isBtnDisable: false,
        btnType: 'primary',
        screen: 'replenish',
    },
    {
        btnName: i18n.t('reportUsage.progressBar.UNiDInfo'),
        btnVisibility: false,
        isBtnDisable: true,
        btnType: 'primary',
        screen: 'procedure',
    },
    {
        btnName: i18n.t('reportUsage.reportUsageFooterbuttons.orReportButton'),
        btnVisibility: false,
        isBtnDisable: true,
        btnType: 'primary',
        screen: 'procedure',
    },
    {
        btnName: i18n.t('reportUsage.reportUsageFooterbuttons.reviewButton'),
        btnVisibility: false,
        isBtnDisable: true,
        btnType: 'primary',
        screen: 'procedure',
    },
    {
        btnName: i18n.t('noUsageToReport.submitButton'),
        btnVisibility: false,
        isBtnDisable: true,
        btnType: 'primary',
        screen: 'submit',
    },
    {
        btnName: i18n.t('scheduleSurgery.surgery.SurgeryFooter.nextBtn'),
        btnVisibility: false,
        isBtnDisable: true,
        btnType: 'primary',
    },
];
